<template>
  <div @drop.prevent="onFileDrop" @dragover.prevent>
    <slot v-bind="{ browse }"></slot>
    <input
      :id="id"
      ref="input"
      class="d-none"
      type="file"
      :accept="accept"
      :multiple="multiple"
      @change="onChange"
    />
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

export default {
  name: 'BaseDropzone',
  props: {
    value: {
      type: [Array, File, Object],
      default: () => [],
    },
    accept: {
      type: Array,
      default: () => ['.ris'],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: () => `dropzone-${uuid()}`,
    },
  },
  methods: {
    browse() {
      this.$refs.input.click();
    },
    onChange(e) {
      const uploader = e.target;
      const selectedFiles = uploader.files;
      this.registerFiles(selectedFiles);
      uploader.value = null;
    },
    onFileDrop(e) {
      const selectedFiles = e.dataTransfer.files;
      this.registerFiles(selectedFiles);
    },
    registerFiles(selectedFiles) {
      const invalidFiles = [];
      if (this.multiple) {
        const files = [...(this.value || [])];
        for (let i = 0; i < selectedFiles.length; i++) {
          const file = selectedFiles[i];
          if (this.validateFile(file)) {
            files.push(file);
          } else {
            invalidFiles.push(file);
          }
        }
        if (files.length > 0) {
          this.$emit('input', files);
        }
      } else {
        const file = selectedFiles[0];
        if (this.validateFile(file)) {
          this.$emit('input', file);
        } else {
          invalidFiles.push(file);
        }
      }
      if (invalidFiles.length > 0) {
        this.$emit('invalid', invalidFiles);
      }
    },
    validateFile(file) {
      const fileExtensionValid = this.accept.some((ext) =>
        file.name.toLowerCase().endsWith(ext)
      );

      const filePreviouslyNotAdded = this.multiple
        ? !this.value || !this.value.some((f) => f.name === file.name)
        : !this.value || this.value.name !== file.name;

      return fileExtensionValid && filePreviouslyNotAdded;
    },
  },
};
</script>
